import type { QueryClient } from '@tanstack/react-query';

import { localStorage } from '@change-corgi/core/storage';

import type { PetitionDraft } from '#src/app/shared/api/petitionDraft';
import { findOrCreateDraftAuthorId } from '#src/app/shared/api/petitionDraft';
import type { UtilityContextWithTracker } from '#src/app/shared/contexts/asyncData';

import type { StartAPetitionDataQuery, StartAPetitionDataQueryVariables } from './api.graphql';
import { StartAPetitionData } from './api.graphql';
import { findOrCreateDraft } from './findOrCreateDraft';

export type StartAPetitionPageData = Pick<StartAPetitionDataQuery, 'featureConfigs' | 'experiments'> & {
	draft: PetitionDraft;
};

export async function getStartAPetitionPageData(
	utilityContext: UtilityContextWithTracker,
	queryClient: QueryClient,
): Promise<StartAPetitionPageData> {
	const { data } = await utilityContext.gql.fetch<StartAPetitionDataQuery, StartAPetitionDataQueryVariables>({
		query: StartAPetitionData,
		rejectOnError: true,
	});

	// get persistent visitor id
	const draftAuthorId = findOrCreateDraftAuthorId({ storage: localStorage, queryClient });
	const currentDraft = await findOrCreateDraft({ ...data, draftAuthorId }, { ...utilityContext, queryClient });

	return {
		draft: currentDraft,
		featureConfigs: data.featureConfigs,
		experiments: data.experiments,
	};
}
